var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datePickerContainer",attrs:{"id":"exportDatePicker"}},[_c('div',{staticClass:"selectDate"},[_c('div',{class:{
				startDate: true,
				startDateSelected: _vm.focusingField === 'startDate'
			}},[_c('small',[_vm._v("From")]),_c('p',[_vm._v(_vm._s(_vm.userSelectedStartDate))])]),_c('div',{class:{
				endDate: true,
				endDateSelected: _vm.focusingField === 'endDate'
			}},[_c('small',[_vm._v("To")]),_c('p',[_vm._v(_vm._s(_vm.userSelectedEndDate || "Tap a Date"))])])]),_c('div',{staticClass:"datepicker"},[_c('datepicker',{attrs:{"value":_vm.selectedDateInPicker,"inline":true,"highlighted":_vm.highlightedDates},on:{"selected":_vm.userPickADate}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }